module.exports = __webpack_public_path__ + "img/checked_bgWhite.b4535fee.svg";